import { toast } from 'react-toastify'
import { localize } from 'store/modules/localization'
import { commonErrorHandler } from './errorHandler'
import { actionTypes } from './actionTypes'
import { buildLookupRequest } from 'utils/odata'
import { format } from 'utils/stringUtilities'

export const handleError = (prefix, { getState, dispatch, error, update }) => commonErrorHandler(actionTypes(prefix).error, { getState, dispatch, error, update })

export const lookupActionCreators = (prefix, api) => ({
  get: (staticFilters = [], sortFieldName) => ({
    type: actionTypes(prefix).entity,
    payload: () => api.get(buildLookupRequest(0, null, 'name', '', staticFilters, sortFieldName))
  })  
})

export const actionCreators = (prefix, api, overrides) => {
  return {
    get: (getInput = {}, delta) => (dispatch) => {
      const { forceGet, ...input } = getInput
      if (input.id === 0 && !forceGet) { dispatch(actionCreators(prefix).create(delta)) }
      if (input.id !== 0 || forceGet) {
        dispatch({
          type: actionTypes(prefix).entity,
          payload: () => api.getEntity(input.id)
        })
      }
    },
    update: (delta, options) => ({
      type: actionTypes(prefix).update,
      payload: { delta, options }
    }),
    create: (delta) => ({
      type: actionTypes(prefix).create,
      payload: { delta }
    }),
    refresh: () => ({
      type: actionTypes(prefix).refresh
    }),
    save: (entity, callback, notificationText) => (dispatch, getState) => {
      dispatch({ type: actionTypes(prefix).saving })
      const updateApi = (overrides && overrides.saveApi) ||
        (entity.id === 0 ? api.create : api.update)
      const { isDirty, ...data } = entity
      updateApi(data)
        .then(response => {
          dispatch({ type: actionTypes(prefix).saved, payload: response })
          toast.info(localize(getState().localization, notificationText || 'common.saved'))
          if (typeof callback === 'function') { callback(response) }
        })
        .catch(error => handleError(prefix, { getState, dispatch, error, update: { saving: false } }))
    },
    saveAll: (e, callback, notificationText) => (dispatch, getState) => {
      dispatch({ type: actionTypes(prefix).saving })
      const { isDirty, ...data } = e.entityDto
      api.updateAll({ entityDto: data, selectedIds: e.selectedIds })
        .then(response => {
          dispatch({ type: actionTypes(prefix).saved, payload: data })
          toast.info(format(localize(getState().localization, notificationText || 'common.allSaved'), e.selectedIds.length))
          if (typeof callback === 'function') { callback(response) }
        })
        .catch(error => handleError(prefix, { getState, dispatch, error, update: { saving: false } }))
    },
    delete: (entity, callback) => (dispatch, getState) => {
      dispatch({ type: actionTypes(prefix).deleting })
      api.delete(entity.id)
        .then(response => {
          dispatch({ type: actionTypes(prefix).deleted, payload: entity.id })
          toast.info(localize(getState().localization, 'common.deleted'))
          if (typeof callback === 'function') { callback(entity) }
        })
        .catch(error => handleError(prefix, { getState, dispatch, error, update: { deleting: false } }))
    },
    hardDelete: (entity, callback) => (dispatch, getState) => {
      dispatch({ type: actionTypes(prefix).deleting })
      api.hardDelete(entity.id)
        .then(() => {
          dispatch({ type: actionTypes(prefix).deleted })
          toast.info(localize(getState().localization, 'common.hardDeleted'))
          if (typeof callback === 'function') { callback(entity) }
        })
        .catch(error => handleError(prefix, { getState, dispatch, error, update: { deleting: false } }))
    },
    emptyTrash: (callback) => (dispatch, getState) => {
      dispatch({ type: actionTypes(prefix).deleting })
      api.emptyTrash()
        .then(() => {
          dispatch({ type: actionTypes(prefix).deleted })
          toast.info(localize(getState().localization, 'common.trashEmptied'))
          if (typeof callback === 'function') { callback() }
        })
        .catch(error => handleError(prefix, { getState, dispatch, error, update: { deleting: false } }))
    },
    restore: (id, callback) => (dispatch, getState) => {
      dispatch({ type: actionTypes(prefix).restoring })
      api.restore(id)
        .then(response => {
          dispatch({ type: actionTypes(prefix).restored })
          toast.info(localize(getState().localization, 'common.restored'))
          if (typeof callback === 'function') { callback(id) }
        })
        .catch(error => handleError(prefix, { getState, dispatch, error, update: { restoring: false } }))
    }
  }
}